<template>
  <!-- 修改密码界面 -->
  <el-dialog
    title="修改密码"
    width="40%"
    :visible.sync="cgpwdVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <el-form
      :model="dataForm"
      label-width="80px"
      :rules="dataFormRules"
      ref="dataForm"
      :size="size"
      label-position="right"
    >
      <el-form-item label="旧的密码" prop="old_password">
        <el-input
          v-model="dataForm.old_password"
          type="password"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="新的密码" prop="new_password">
        <el-input
          v-model="dataForm.new_password"
          type="password"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model="dataForm.confirmPassword"
          type="password"
          auto-complete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="margin-top: 5px">
      <el-button :size="size" @click.native="cgpwdVisible = false"
        >关闭</el-button
      >
      <el-button
        :size="size"
        type="primary"
        @click.native="submitForm"
        :loading="editLoading"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
//import axios from "axios";
import * as API from "@/api/index.js"
var validateCode = (rule, value, callback) => {
  // const age = /^[0-9a-zA-Z]+$/;
  // if (value && !age.test(value)) {
  //   callback(new Error("格式不正确，需要为数字或是英文字母"));
  // } else {
    callback();
  // }
};
export default {
  name: "CgPwd",
  data: function () {
    return {
      size: "small",
      cgpwdVisible: false, // 编辑界面是否显示
      editLoading: false, //载入图标
      //初始化数据
      dataForm: {
        old_password: "",
        new_password: "",
        confirmPassword: ""
      },

      //设置属性
      dataFormRules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        new_password: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
            min: 8,
            max: 32,
            message: "不能少于8位",
          },
          { validator: validateCode, trigger: "blur" },
        ],
        confirmPassword:  [
          { required: true, validator: (rule, value, callback) => {
            if (value) {
              if(value === this.dataForm.new_password) {
                callback();
              } else {
                callback(new Error("两次密码输入不一致"));
              }
            } else {
              callback(new Error("请输入确认密码"));
            }
          }, trigger: "blur" },
        ]
      }
    };
  },
  methods: {
    // 设置可见性
    setCgpwdVisible: function (cgpwdVisible) {
      this.cgpwdVisible = cgpwdVisible;
      console.log(this.cgpwdVisible);
    }, // 提交请求

    submitForm: function () {
      //this.$refs.XXX 获取ref绑定的节点
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            try {
              this.editLoading = true;
              let params = Object.assign({}, this.dataForm);
              const response =  await API.PUT('/omnis/system/updatepass',params);
              let data = response.data;
              if (data.success) {
                this.$message.success(data.msg);
                this.cgpwdVisible = false //隐藏该窗口
                this.$refs["dataForm"].resetFields(); //重置表单
                this.$emit('afterRestore')
              } else {
                this.$message.error(data.msg);
              }
            } finally {
              this.editLoading = false;
            }
          });
        }
      });
    },
  },
  //mounted： 在这发起后端请求，拿回数据，配合路由钩子做一些事情  （dom渲染完成 组件挂载完成 ）
  mounted() {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// change_password.vue?caa1a1f0